import { apiUrls } from '../../constants/apiUrls';
import { handlePromise } from '../helpers';
import env from '../../environments';

export const fetchUserDataAPI = async () => {
  const apiPayload = {
    method: 'GET',
    url: apiUrls.fetchUserData
  };

  return handlePromise(apiPayload);
};


export const preferredDashboard = async (params) => {
  const apiPayload = {
    method: 'PUT',
    url: apiUrls.preferredDashboard,
    params
  };
  return handlePromise(apiPayload);
};

export const fetchForm = async (params) => {
  const apiPayload = {
    method: 'GET',
    url: env.getLcoBasePath() + apiUrls.fetchUserForm,
    params
  };
  return handlePromise(apiPayload);
};

export const saveForm = async (data) => {
  const apiPayload = {
    method: 'POST',
    url: env.getLcoBasePath() + apiUrls.saveUserForm,
    data
  };
  return handlePromise(apiPayload);
};

export const updateTask = async (data, headers) => {
  const apiPayload = {
    method: 'PUT',
    url: apiUrls.updateTask,
    data,
    headers
  };  

  return handlePromise(apiPayload);
}

export const uploadFileService = async (data, headers) => {
  const apiPayload = {
    method: 'POST',
    url: env.getLcoBasePath() + apiUrls.uploadFile,
    data,
    headers
  };  

  return handlePromise(apiPayload);
}